
import CarItem from "./components/car-item.vue";
import UserFeedback from "./components/user-feedback.vue";
import { Component, Vue } from "vue-property-decorator";
import i18n from "@/config/i18n";

@Component({ components: { CarItem, UserFeedback } })
export default class SystemConfigLog extends Vue {
  private tabsList: object[] = [
    { name: "tab1", title: i18n.t("car.carDirectory"), value: 1 },
    { name: "tab2", title: i18n.t("car.userFeedback"), value: 2 }
  ];
  private tabsActive = "tab1";

  public tabChange(data: string): void {
    this.tabsActive = data;
  }
}
